
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2,0,0,2,0,0)"}},[_c('defs',[_c('style',[_v('.a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}')])]),_c('title',[_v('database-sync')]),_c('path',{staticClass:"a",attrs:{"d":"M12,9.751C5.787,9.751.75,7.736.75,5.251S5.787.751,12,.751s11.25,2.014,11.25,4.5c0,1.323-1.428,2.513-3.7,3.337"}}),_c('line',{staticClass:"a",attrs:{"x1":"23.25","y1":"9.016","x2":"23.25","y2":"5.251"}}),_c('path',{staticClass:"a",attrs:{"d":"M.75,5.251v6c0,2.067,3.486,3.809,8.235,4.336"}}),_c('path',{staticClass:"a",attrs:{"d":"M.75,11.251v6c0,1.96,3.134,3.628,7.508,4.245"}}),_c('polyline',{staticClass:"a",attrs:{"points":"15 18.751 11.25 18.751 11.25 22.501"}}),_c('path',{staticClass:"a",attrs:{"d":"M22.667,19.484a5.572,5.572,0,0,1-10.74-.733"}}),_c('polyline',{staticClass:"a",attrs:{"points":"19.5 15.751 23.25 15.751 23.25 12.001"}}),_c('path',{staticClass:"a",attrs:{"d":"M11.833,15.017a5.573,5.573,0,0,1,10.74.734"}})])])
          )
        }
      }
    